/* unplugin-vue-components disabled */import { render } from "./BigButton.vue?vue&type=template&id=16f60ae4&scoped=true&ts=true"
import script from "./BigButton.vue?vue&type=script&lang=ts"
export * from "./BigButton.vue?vue&type=script&lang=ts"

import "./BigButton.vue?vue&type=style&index=0&id=16f60ae4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f60ae4"]])

export default __exports__